<template>
  <div>
    Sie wurden abgemeldet.
    <p @click="login">
      Login
    </p>
  </div>
</template>

<script>
import authService from '../auth/authService'
export default {
    name: 'SignedOutView',
    methods: {
        login () {
            localStorage.setItem('loginRedirect', this.$route.fullPath)
            authService.login()
        }
    }
}
</script>

<style scoped>

</style>